import { CategoryResource } from "@/services";
import { catchErrors } from "../../lib/errorHandlers";
import Vue from "vue";

const state = {
  categories: [],
  loading: false,
  loaded: false
};

const getters = {
  getCategories: state => state.categories,
  getLoaded: state => state.loaded,
  getCategoryById: state => id => {
    return state.categories.find(category => category.id === id);
  },
  getCategoryByCode: state => code => {
    return state.categories.find(category => category.code === code) || null;
  },
  getUpdatesCategoryId: (state, getters) => {
    let category = getters.getCategoryByCode("updates");
    return category ? category.id : null;
  },
  getStatusReportsCategoryId: (state, getters) => {
    let category = getters.getCategoryByCode("statusReports");
    return category ? category.id : null;
  },
  getDeveloperUpdatesCategoryId: (state, getters) => {
    let category = getters.getCategoryByCode("developerUpdates");
    return category ? category.id : null;
  }
};

const actions = {
  async getCategories({ state, commit }) {
    return catchErrors(async () => {
      const response = await CategoryResource.get();
      const categories = response.data;

      commit("setCategories", categories);
    }, "Unable to load <strong>Categories</strong>");
  },
  async getCategoriesById({ state, commit, getters, dispatch }, ids) {
    if (!state.categories.length) {
      await dispatch("getCategories");
    }

    return ids.map(id => getters.getCategoryById(id));
  }
};

const mutations = {
  setLoading(state, val) {
    state.loading = val;
  },
  setCategories(state, categories) {
    Vue.set(state, "categories", categories);
    Vue.set(state, "loaded", true);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
